import Vue from "vue";

function deepSet (obj, props, value) {
	const splitProps = props.split(".");
	const prop = splitProps.shift();
	if (!obj[prop]) {
		Vue.set(obj, prop, {});
	}
	if (!splitProps.length) {
		if (value && typeof value === "object" && !Array.isArray(value)) {
			obj[prop] = { ...obj[prop], ...value };
		} else {
			obj[prop] = value;
		}
		return;
	}
	deepSet(obj[prop], splitProps.join("."), value);
}

export default deepSet;